import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Badge from "components/bootstrap/Badge";
import { GLCheckboxWithScope, RowTitleButton } from "common/components";
import { Table } from "components/bootstrap";
import { RiskScoreBadge } from "security-app/components/common";
import { useSelectedRows, useSelectedRowsDispatch } from "common/contexts";
import OwnerCell from "security-app/components/SecurityEvents/Alerts/OwnerCell";
const EventTitle = styled.span`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
const EventContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs};
`;
const EventMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacings.sm};
`;
const EventMetaRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.sm};
`;
function EventList({ securityEvents = [], onEventSelect }) {
  const { t } = useTranslation("enterprise_security_assets");
  const selectedSecEvents = useSelectedRows();
  const selectedSecEventsDispatch = useSelectedRowsDispatch();
  const onRowTitleClick = (inSecurityEvent) => () => {
    onEventSelect(inSecurityEvent.event_id);
  };
  const isSelected = useCallback(
    (secEvent) => !!selectedSecEvents.find((sSecEvent) => secEvent.event_id === sSecEvent.event_id),
    [selectedSecEvents]
  );
  const onSelect = useCallback(
    (secEvent) => (e) => {
      if (e.target.checked) {
        selectedSecEventsDispatch({ type: "add", payload: [secEvent], key: "event_id" });
      } else {
        selectedSecEventsDispatch({ type: "remove", payload: [secEvent], key: "event_id" });
      }
    },
    [selectedSecEventsDispatch]
  );
  return /* @__PURE__ */ React.createElement(Table, { condensed: true }, /* @__PURE__ */ React.createElement("tbody", null, securityEvents.map((securityEvent) => {
    var _a;
    return /* @__PURE__ */ React.createElement("tr", { key: securityEvent.event_id }, /* @__PURE__ */ React.createElement("td", { style: { width: "34px" } }, /* @__PURE__ */ React.createElement(GLCheckboxWithScope, { entity: securityEvent, isSelected, onSelect })), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(EventContent, null, /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: onRowTitleClick(securityEvent) }, /* @__PURE__ */ React.createElement(EventTitle, { title: securityEvent.message }, securityEvent.message)), /* @__PURE__ */ React.createElement(EventMeta, null, securityEvent.owner ? /* @__PURE__ */ React.createElement(OwnerCell, { owner: securityEvent.owner }) : /* @__PURE__ */ React.createElement("i", null, t("security_events_event_list.no_owner_assigned")), /* @__PURE__ */ React.createElement(EventMetaRight, null, /* @__PURE__ */ React.createElement(Badge, null, securityEvent.status), /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: (_a = securityEvent.scores) == null ? void 0 : _a.normalized_risk }))))));
  })));
}
export default EventList;
